module.exports = __webpack_public_path__ + "img/mana4.373beda4.png";